import { createContext, useContext } from "react"

export type ConsentStatus = "accepted" | "declined" | null

export interface ConsentContextType {
	status: ConsentStatus
	accept: () => void
	decline: () => void
	reset: () => void
}

export const ConsentContext = createContext<ConsentContextType | null>(null)

export function useConsent(): ConsentContextType {
	const ctx = useContext(ConsentContext)
	if (!ctx) throw new Error("useConsent must be used within ConsentProvider")
	return ctx
}
